import { Box, DialogContent, MenuItem, Grid } from '@mui/material';
import {
  HorizontalForm,
  CustomTextField,
  CustomSelect,
  CustomTextArea,
} from '../../../../../common/components';

/**
 * Tab de datos generales del proyecto
 * Siguiendo el patrón del ContractIndividualEditDialog
 */
const GeneralDataTab = ({ localProject, handleInputChange, handleSelectChange }) => {
  const statusOptions = [
    { value: 'not_started', label: 'Sin empezar' },
    { value: 'in_progress', label: 'En progreso' },
    { value: 'completed', label: 'Completado' },
    { value: 'cancelled', label: 'Cancelado' },
  ];

  return (
    <Box>
      <DialogContent>
        <Grid container spacing={3}>
          {/* Columna Izquierda: Nombre y Descripción */}
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <CustomTextField
                label="Nombre del Proyecto"
                name="name"
                value={localProject?.name || ''}
                onChange={handleInputChange}
                size="medium"
                required
                fullWidth
              />

              <CustomTextArea
                label="Descripción"
                name="description"
                value={localProject?.description || ''}
                onChange={handleInputChange}
                size="medium"
                multiline
                rows={3}
                fullWidth
              />
            </Box>
          </Grid>

          {/* Columna Derecha: Estado y Fechas */}
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <CustomSelect
                label="Estado"
                name="status"
                value={localProject?.status || 'not_started'}
                onChange={handleSelectChange}
                size="medium"
                fullWidth
              >
                {statusOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </CustomSelect>

              <CustomTextField
                label="Fecha de Inicio"
                name="start_date"
                type="date"
                value={localProject?.start_date || ''}
                onChange={handleInputChange}
                size="medium"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />

              <CustomTextField
                label="Fecha de Fin"
                name="end_date"
                type="date"
                value={localProject?.end_date || ''}
                onChange={handleInputChange}
                size="medium"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Box>
  );
};

export default GeneralDataTab;
